import * as angular from 'angular';
import * as _ from 'lodash';

import { IStoreService, ITranslatedLoggerService } from '../../../services';
import { Miniature, ComponentDefinition, ContextualField, UserGroups } from '../../../models';
import { guidEmpty, getGuid } from '../../../common';
import { IUserGroupFactory } from '../userGroups/userGroup.factory';
import { MixedUserChoice, UserType } from '../../../models/mailing/MixedUserChoice';
import { Name } from '../../../common/helpers/contextual';
import { SaveCancelObject } from '../userGroups/SaveCancelObject';

class UserGroupsContextualController implements angular.IComponentController {
    externalFormController: angular.IFormController;
    formController: angular.IFormController;
    miniatures: Miniature[];
    guidEmpty = guidEmpty;
    isLoading = false;
    keepSelectedUser: boolean;
    modernDesign: boolean;
    properties: ContextualField[];
    selectedChoices: MixedUserChoice[];
    selectedItem: UserGroups;
    userGroupNameField: ContextualField;
    userGroups: UserGroups[] = [];
    usersListChanged = true;
    saveCancelObject : SaveCancelObject;

    private _originalSelectedChoices: MixedUserChoice[];
    private _originalUserGroup: UserGroups;

    static $inject = [
        '$scope',
        '$translate',
        'translatedLoggerService',
        'storeService',
        'userGroupFactory',
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$translate: angular.translate.ITranslateService,
        private _loggerService: ITranslatedLoggerService,
        private _storeService: IStoreService,
        private _userGroupFactory: IUserGroupFactory,
    ) {
    }

    $onInit() {
        this.saveCancelObject = { 
            save : this.save.bind(this),
            cancel: this.cancel.bind(this)
        };
        this.initMiniatureList();
        this.modernDesign = true;
        this._$scope.$watch(() => this.selectedItem, () => {
            this.initProperties();
            if (this.selectedItem) {
                this._originalUserGroup = angular.copy(this.selectedItem);
                this._originalSelectedChoices = angular.copy(this.selectedChoices);
            }
        });
    }

    initProperties() {
        const nameField = angular.copy(Name);
        nameField.isValid = newName => this.validateName(newName);
        this.properties = [nameField];
    }

    private initMiniatureList(): void {
        this.miniatures = this._userGroupFactory.getMiniatureList();
    }

    cancel(): void {
        angular.copy(this._originalUserGroup, this.selectedItem);
        angular.copy(this._originalSelectedChoices, this.selectedChoices);
        this.initProperties();
        this.selectedItem = null;
    }

    save() {
        this.isLoading = true;
        if (this.selectedItem.guid == undefined || this.selectedItem.guid === guidEmpty ) {
            this.selectedItem.guid = getGuid();
        }    
        // this.selectedChoices = this.selectedChoices.filter((x,i,a)=> a.indexOf(x)==i);    
        const userCollection = this.selectedChoices.filter(c => c.type === UserType.User).map(u => u.originalObject.userId);
        this.selectedItem.userCollection = userCollection;
        return this._storeService.dispatchers().userGroups.updateOne(this.selectedItem)
            .then(data => {
                this._loggerService.logSuccess(this._$translate.instant('Successfully saved user group.'));
                this.formController.$setPristine();
                this.externalFormController.$setPristine();
                this.selectedChoices = this.selectedChoices.sort(this.sortChoices);
            })
            .catch(() => {
                this._loggerService.logError(this._$translate.instant('Failed to save user group.'));
            })
            .finally(() => {
                this.isLoading = false;
            });  
    }

    validateName(newName: string): { [key: string]: boolean } {
        let hasDuplicate = false;
        const groupName = newName;
        if (groupName && this.userGroups) {
            hasDuplicate = _.some(this.userGroups, u => u.name
                && u.name.toLowerCase() === groupName.toLowerCase()
                && this.selectedItem !== u);
        }
        return { 'duplicate': !hasDuplicate };
    }

    //todo extract do common functions
    private sortChoices(a: { name: string }, b: { name: string }): number {
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    }
}

export const wtUserGroupsContextual: ComponentDefinition = {
    componentId: 'wtUserGroupsContextual',
    controller: UserGroupsContextualController,
    template: require('./userGroupsContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        externalFormController: '<?',
        isLoading: '<',
        selectedChoices: '<',
        selectedItem: '=',
        userGroups: '<',
        saveCancelObject: '='
    },
};